import React, { useMemo, useState } from 'react';
import { Icon, Input, Select, Tooltip } from 'antd';
import { useHomeCustomizationStore } from './store';
import useDebounce from 'react-use/lib/useDebounce';
import DragHandle from 'components/miscellaneous/DragHandle';

export default function Link({ homePageLink, groupId }) {
  const [name, setName] = useState(homePageLink.name),
    [link, setLink] = useState(homePageLink.link),
    [isInternal, setIsInternal] = useState(homePageLink.isInternal);
  const { updateLink, removeLink } = useHomeCustomizationStore();

  useDebounce(
    () => {
      updateLink(groupId, homePageLink.id, {
        name,
        link,
        isInternal,
      });
    },
    200,
    [name, link, isInternal, groupId, homePageLink.id],
  );

  const renderForm = useMemo(() => {
    return (
      <div className="flex w-full items-center space-x-2">
        <div className="space-y-2 w-full">
          <div className="flex w-full items-center space-x-2">
            <p style={{ marginBottom: 0, width: 100, fontSize: 10 }}>
              Display Name
            </p>
            <Input
              placeholder="Display Name"
              size="small"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>
          <div className="flex w-full items-center space-x-2">
            <p style={{ marginBottom: 0, width: 100, fontSize: 10 }}>URL</p>
            <Input
              addonAfter={
                <Tooltip title="Internal link is link within https://mail.turing.com. For Internal Link, only input relative path, for example /unsubscription">
                  <Select
                    value={isInternal.toString()}
                    onChange={value => {
                      setIsInternal(value === 'true');
                    }}
                  >
                    <Select.Option value="false">External Link</Select.Option>
                    <Select.Option value="true">Internal Link</Select.Option>
                  </Select>
                </Tooltip>
              }
              placeholder="URL"
              size="small"
              value={link}
              onChange={e => setLink(e.target.value)}
            />
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Icon
            style={{ fontSize: 16 }}
            theme="twoTone"
            twoToneColor="#ff3333"
            type="delete"
            onClick={() => {
              removeLink(groupId, homePageLink.id);
            }}
          />
          <DragHandle />
        </div>
      </div>
    );
  }, [name, link, isInternal, groupId, homePageLink, updateLink]);

  return <div className="w-full">{renderForm}</div>;
}
